module.exports = __webpack_public_path__ + "img/A49994_695244_C4C2CF_76645C-256px.b62366a3.png";